export default __webpack_public_path__ + "de66cd63964e383c60514e9eee097d0e.svg";